import { render } from "./PageDropDownMenuSelector.vue?vue&type=template&id=1d82d1a1"
import script from "./PageDropDownMenuSelector.vue?vue&type=script&lang=js"
export * from "./PageDropDownMenuSelector.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/360pt/V3/v2026.32.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__